// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2xnR2","title":"ClientInsurance_title___1NUN","itemText":"ClientInsurance_itemText__Q-7gA"};